'use client';

import { signalHitlConfig } from '../../tools/signal/hitl-config';
import { EnhancedEditSignalForm } from '../forms/EnhancedEditSignalForm';
import type { SignalData } from '../types';
import type { EditContentProps } from '../../tool-config-types';

export function SignalEditContentWrapper({
  onClose,
  onSubmit,
  onApprove,
  onReject,
  toolName,
  extractedData = [],
}: EditContentProps) {
  const hitlConfig = signalHitlConfig;

  const handleSubmit = (editedSignals: SignalData[]) => {
    if (!hitlConfig) return;
    const wrappedData = hitlConfig.wrapEditedData(editedSignals);
    onSubmit(wrappedData);
    onClose();
  };

  const handleApprove = () => {
    onApprove?.();
    onClose();
  };

  if (extractedData.length === 0) return null;

  return (
    <EnhancedEditSignalForm
      onClose={onClose}
      onSubmit={handleSubmit}
      signals={extractedData as SignalData[]}
      actionName={toolName}
      allowSubmitWithoutChanges={Boolean(onApprove)}
      onApprove={handleApprove}
      onReject={onReject}
    />
  );
}
